export default __webpack_public_path__ + "static/media/pexels-anna-shvets-4225920.159fd905.jpg";